<template>
  <b-modal size="lg" title="Geokoduj adresy" v-model="showModal" @hide="cancel">
    <b-alert :show="submitingItemsInProgress" variant="success">
      <span
        >Załadowano {{ submitItemsCounter }} obiektów z
        {{ items ? items.length : 0 }} obiektów.</span
      >
    </b-alert>
    <b-form class="  p-0">
      <b-alert :show="items !== null" variant="success">
        <span
          >Pobrano informację o {{ items ? items.length : 0 }} obiektach.</span
        >
        <br />
        <span v-if="items && items.length % terytAdressLimit === 0">
          Pobrane obiekty stanowią jedynie część obiektów z wybranego obszaru.
        </span>
      </b-alert>

      <b-form-group label="Województwo" label-for="teryt-province-select">
        <small
          class="text-danger"
          v-show="terytSearchErrors.terytProvinceNotSelected"
          >Należy wybrać województwo.</small
        >
        <b-form-select
          id="teryt-province-select"
          v-model="selectedProvince"
          @change="provinceChanged"
          :class="{
            'is-invalid': terytSearchErrors.terytProvinceNotSelected,
            'form-control': true
          }"
        >
          <option :value="null" disabled>Wybierz</option>
          <option
            v-for="province in provinces"
            :key="province.teryt"
            :value="province"
          >
            {{ province.name }}
          </option>
        </b-form-select>
      </b-form-group>
      <b-form-group label="Powiat" label-for="teryt-district-select">
        <small
          class="text-danger"
          v-show="terytSearchErrors.terytDistrictNotSelected"
          >Należy wybrać powiat.</small
        >
        <b-form-select
          id="teryt-district-select"
          v-model="selectedDistrict"
          @change="districtChanged"
          :class="{
            'is-invalid': terytSearchErrors.terytDistrictNotSelected,
            'form-control': true
          }"
        >
          <option :value="null" disabled>Wybierz</option>
          <option
            v-for="district in districts"
            :key="district.teryt"
            :value="district"
          >
            {{ district.name }}
          </option>
        </b-form-select>
      </b-form-group>
      <b-form-group label="Gmina" label-for="teryt-commune-select">
        <small
          class="text-danger"
          v-show="terytSearchErrors.terytCommuneNotSelected"
          >Należy wybrać gminę.</small
        >
        <b-form-select
          id="teryt-commune-select"
          v-model="selectedCommune"
          @change="communeChanged"
          :class="{
            'is-invalid': terytSearchErrors.terytCommuneNotSelected,
            'form-control': true
          }"
        >
          <option :value="null" disabled>Wybierz</option>
          <option
            v-for="commune in communes"
            :key="commune.teryt"
            :value="commune"
          >
            {{ commune.name }}
          </option>
        </b-form-select>
      </b-form-group>
      <b-form-group label="Miasto" label-for="teryt-city-select">
        <small
          class="text-danger"
          v-show="terytSearchErrors.terytCityNotSelected"
          >Należy wybrać miasto.</small
        >
        <b-form-select
          id="teryt-city-select"
          v-model="selectedCity"
          @change="cityChanged"
          :class="{
            'is-invalid': terytSearchErrors.terytCityNotSelected,
            'form-control': true
          }"
        >
          <option :value="null" disabled>Wybierz</option>
          <option v-for="city in cities" :key="city.id" :value="city">
            {{ city.name }}
          </option>
        </b-form-select>
      </b-form-group>
      <b-form-group label="Ulica" label-for="teryt-street-select">
        <small
          class="text-danger"
          v-show="terytSearchErrors.terytStreetNotSelected"
          >Należy wybrać ulicę.</small
        >
        <b-form-select
          id="teryt-street-select"
          v-model="selectedStreet"
          @change="streetChanged"
          :class="{
            'is-invalid': terytSearchErrors.terytStreetNotSelected,
            'form-control': true
          }"
        >
          <option :value="null">Wybierz</option>
          <option v-for="street in streets" :key="street.ulic" :value="street">
            {{ street.name1 }}
          </option>
        </b-form-select>
      </b-form-group>

      <b-form-group class="d-flex justify-content-end m-0">
        <b-btn
          v-if="terytAdressSkip == 0"
          variant="primary"
          :disabled="!selectedCity || isAdressLoading"
          @click="getItems()"
          ><span v-if="!isAdressLoading">Pobierz informacje o obiektach</span
          ><span v-else><icon name="circle-notch" spin/></span></b-btn
        ><b-btn
          v-if="
            terytAdressSkip && this.items.length % this.terytAdressLimit == 0
          "
          variant="primary"
          :disabled="!selectedCity || isAdressLoading"
          @click="getItems()"
        >
          <span v-if="!isAdressLoading"
            >Pobierz informacje o kolejnych obiektach</span
          ><span v-else><icon name="circle-notch" spin/></span
        ></b-btn>
      </b-form-group>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <b-btn
        class="float-right ml-2"
        variant="primary"
        :disabled="!items"
        @click="saveItems()"
        >Zapisz</b-btn
      >
      <b-btn
        class="float-right ml-2"
        variant="outline-secondary"
        @click="cancel()"
        >Anuluj</b-btn
      >
    </div>
    <loading-overlay
      :active.sync="this.isLoading"
      :is-full-page="true"
    ></loading-overlay>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import { WINDOW_NOTIFICATION_SHOW } from '../../store/mutations.type';
import { Api as SearchApi } from '../../api/api-wyszukiwarka.js';
import LoadingOverlay from 'vue-loading-overlay';

import {
  EDIT_SESSION_ADD_FEATURE,
  EDIT_SESSION_TRANSFORM_GEOMETRY_TO_FEATURE_GEOMETRY
} from '../../store/actions.type';

export default {
  name: 'AdressSearchModal',
  components: { LoadingOverlay },
  props: {
    showAddManyFeaturesModal: false
  },
  computed: {
    ...mapGetters(['featuresColumns', 'activeLayer'])
  },
  watch: {
    showAddManyFeaturesModal: function(newVal) {
      this.showModal = newVal;
    }
  },
  data() {
    return {
      showModal: false,
      isLoading: false,
      isAdressLoading: false,
      provinces: [],
      selectedProvince: null,
      districts: [],
      selectedDistrict: null,
      communes: [],
      selectedCommune: null,
      cities: [],
      selectedCity: null,
      teryt: null,
      terytAdressLimit: 500,
      terytAdressSkip: 0,
      streets: [],
      selectedStreet: null,
      terytSearchErrors: {
        terytCodeIsEmpty: false,
        terytProvinceNotSelected: false,
        terytDistrictNotSelected: false,
        terytCommuneNotSelected: false,
        terytCityNotSelected: false
      },
      items: null,
      submitItemsCounter: 0,
      submitingItemsInProgress: false
    };
  },
  methods: {
    cancel() {
      this.setInitVariables();
      this.$emit('cancel');
    },
    setInitVariables() {
      // this.provinces = [];
      this.selectedProvince = null;
      this.districts = [];
      this.selectedDistrict = null;
      this.communes = [];
      this.selectedCommune = null;
      this.cities = [];
      this.selectedCity = null;
      this.teryt = null;
      this.streets = [];
      this.selectedStreet = null;
      this.terytSearchErrors.terytCodeIsEmpty = false;
      this.terytSearchErrors.terytProvinceNotSelected = false;
      this.terytSearchErrors.terytDistrictNotSelected = false;
      this.terytSearchErrors.terytCommuneNotSelected = false;
      this.terytSearchErrors.terytCityNotSelected = false;
      this.items = null;
      this.terytAdressSkip = 0;
    },
    saveItems() {
      this.isLoading = true;
      this.submitItems();
      this.isLoading = false;
      this.cancel();
    },
    async getTerytSearchData(searchPerimeters) {
      this.isLoading = true;
      try {
        const api = new SearchApi();

        const response = await api.getWyszukiwarkaAll({
          wso2_id: this.contextEmail ? this.contextEmail : null,
          orgid: this.contextOrganizationId ? this.contextOrganizationId : null,
          teryt: this.terytCode,
          woj: this.selectedProvince != null ? this.selectedProvince.nazwa : '',
          pow: this.selectedDistrict != null ? this.selectedDistrict.nazwa : '',
          gmi: this.selectedCommune != null ? this.selectedCommune.nazwa : ''
        });
        if (response) {
          this.provinces = response.body.wojewodztwa;
          this.districts = response.body.powiaty;
          this.communes = response.body.gminy;

          this.selectedProvince = response.body.wojewodztwo;
          this.selectedDistrict = response.body.powiat;
          this.selectedCommune = response.body.gmina;

          // jesli nastapila zmiana kodu teryt
          if (
            searchPerimeters &&
            this.selectedDistrict != null &&
            this.selectedCommune != null
          ) {
            this.getPerimeters();
          }
        }
      } catch (e) {
        this.hide();
        this.$emit('showError', e.message);
      } finally {
        this.isLoading = false;
      }
    },
    async getProvinces() {
      this.isLoading = true;
      try {
        const api = new SearchApi();

        const response = await api.getProvinces(
          {},
          { ignoreGlobalErrors: true }
        );
        if (response) {
          this.provinces = response.body;
        }
      } catch (error) {
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          message: error.response || error,
          type: 'error',
          title: 'Uwaga.'
        });
      } finally {
        this.isLoading = false;
      }
    },
    async getDistricts() {
      this.isLoading = true;
      try {
        const api = new SearchApi();

        const response = await api.getDistricts({
          wojewodztwoid: this.selectedProvince.teryt
        });
        if (response) {
          this.districts = response.body;
        }
      } catch (error) {
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          message: error.response || error,
          type: 'error',
          title: 'Uwaga.'
        });
      } finally {
        this.isLoading = false;
      }
    },
    async getCommunes() {
      this.isLoading = true;
      try {
        const api = new SearchApi();

        const response = await api.getCommunes({
          powiatid: this.selectedDistrict.teryt
        });
        if (response) {
          this.communes = response.body;
        }
      } catch (error) {
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          message: error.response || error,
          type: 'error',
          title: 'Uwaga.'
        });
      } finally {
        this.isLoading = false;
      }
    },
    async getCities() {
      this.isLoading = true;
      try {
        const api = new SearchApi();

        const response = await api.getCities({
          gminaid: this.selectedCommune.teryt
        });
        if (response) {
          this.cities = response.body;
        }
      } catch (error) {
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          message: error.response || error,
          type: 'error',
          title: 'Uwaga.'
        });
      } finally {
        this.isLoading = false;
      }
    },
    async getStreets() {
      this.isLoading = true;
      try {
        const api = new SearchApi();

        const response = await api.getStreets({
          simc: this.selectedCity.simc
        });
        if (response) {
          this.streets = response.body;
        }
      } catch (error) {
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          message: error.response || error,
          type: 'error',
          title: 'Uwaga.'
        });
      } finally {
        this.isLoading = false;
      }
    },
    async getItems() {
      if (this.selectedStreet) {
        this.getAddressesForStreet();
      } else {
        this.getAddressesForTeryt();
      }
    },

    async getAddressesForTeryt() {
      this.isAdressLoading = true;
      try {
        const api = new SearchApi();

        const response = await api.getAddressesForTeryt({
          teryt: this.selectedCommune.teryt,
          limit: this.terytAdressLimit,
          skip: this.terytAdressSkip
        });
        if (response) {
          const newItems = response.body.map(item => {
            item.simc = this.selectedCity.simc;
            return item;
          });
          if (this.terytAdressSkip > 0) {
            this.items.push(...newItems);
          } else {
            this.items = newItems;
          }
          if (this.items && this.items.length % this.terytAdressLimit == 0) {
            this.terytAdressSkip = this.terytAdressSkip + this.terytAdressLimit;
          }
        }
      } catch (error) {
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          message: error.response || error,
          type: 'error',
          title: 'Uwaga.'
        });
      } finally {
        this.isAdressLoading = false;
      }
    },
    async getAddressesForStreet() {
      this.isAdressLoading = true;
      try {
        const api = new SearchApi();

        const response = await api.getAddressesForTeryt({
          simc: this.selectedCity.simc,
          ulic: this.selectedStreet.ulic,
          limit: this.terytAdressLimit,
          skip: this.terytAdressSkip
        });
        if (response) {
          const newItems = response.body.map(item => {
            item.simc = this.selectedCity.simc;
            return item;
          });
          if (this.terytAdressSkip > 0) {
            this.items.push(...newItems);
          } else {
            this.items = newItems;
          }
          if (this.items && this.items.length % this.terytAdressLimit == 0) {
            this.terytAdressSkip = this.terytAdressSkip + this.terytAdressLimit;
          }
        }
      } catch (error) {
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          message: error.response || error,
          type: 'error',
          title: 'Uwaga.'
        });
      } finally {
        this.isAdressLoading = false;
      }
    },
    async submitItems() {
      this.submitItemsCounter = 0;
      this.submitingItemsInProgress = true;

      const simcCol = this.featuresColumns[this.activeLayer.id].find(el =>
        el.label.toLowerCase().includes('simc')
      );
      const simcColKey = simcCol && simcCol.key ? simcCol.key : null;
      const ulicCol = this.featuresColumns[this.activeLayer.id].find(el => {
        if (
          el.label.toLowerCase().includes('ulic') ||
          el.label.toLowerCase().includes('numer drogi')
        ) {
          return el;
        }
      });
      const ulicColKey = ulicCol && ulicCol.key ? ulicCol.key : null;
      const tercCol = this.featuresColumns[this.activeLayer.id].find(el => {
        if (
          el.label.toLowerCase().includes('terc') ||
          el.label.toLowerCase().includes('teryt')
        ) {
          return el;
        }
      });
      const tercColKey = tercCol && tercCol.key ? tercCol.key : null;
      const addressNumberCol = this.featuresColumns[this.activeLayer.id].find(
        el => {
          if (el.label.toLowerCase().includes('porządkowy')) {
            return el;
          }
        }
      );
      const addressNumberColKey =
        addressNumberCol && addressNumberCol.key ? addressNumberCol.key : null;
      // Create an array of promises for the asynchronous operations
      const promises = this.items.map(async item => {
        const feature = await this.$store.dispatch(
          EDIT_SESSION_TRANSFORM_GEOMETRY_TO_FEATURE_GEOMETRY,
          [item.x, item.y]
        );

        if (item.simc) {
          feature[simcColKey] = item.simc;
        }
        if (item.streetSymbol) {
          feature[ulicColKey] = item.streetSymbol;
        }
        if (item.teryt) {
          feature[tercColKey] = item.teryt;
        }
        if (item.nr) {
          feature[addressNumberColKey] = item.nr;
        }
        this.$store.dispatch(EDIT_SESSION_ADD_FEATURE, feature);
        this.submitItemsCounter++;
      });

      // Use Promise.all to wait for all promises to resolve
      await Promise.all(promises);

      this.submitItemsCounter = 0;
      this.submitingItemsInProgress = false;
    },

    provinceChanged(province) {
      if (province != null) {
        // this.selectedProvince = province;
        this.selectedDistrict = null;
        this.selectedCommune = null;
        this.selectedCity = null;
        this.selectedStreet = null;
        this.districts = [];
        this.communes = [];
        this.cities = [];
        this.street = [];
        this.terytAdressSkip = 0;
        this.getDistricts();
      }
    },
    districtChanged(district) {
      if (district != null) {
        this.selectedCommune = null;
        this.selectedCity = null;
        this.selectedStreet = null;

        this.communes = [];
        this.cities = [];
        this.street = [];
        this.terytAdressSkip = 0;
        this.getCommunes();
      }
    },
    communeChanged(commune) {
      if (commune != null) {
        this.selectedCity = null;
        this.selectedStreet = null;

        this.cities = [];
        this.street = [];
        this.terytAdressSkip = 0;
        this.getCities();
      }
    },
    cityChanged(city) {
      if (city != null) {
        this.selectedStreet = null;
        this.street = [];
        this.terytAdressSkip = 0;
        this.getStreets();
      }
    },
    streetChanged() {
      this.terytAdressSkip = 0;
    }
  },
  mounted() {
    this.getProvinces();
  }
};
</script>
<style></style>
